<template lang="pug">
div
  .d-flex.justify-space-between.align-center.mb-2.mr-xl-10
    .text-sm.neutral500--text {{ ['quotation', 'stock-transfer'].includes(selectedDocument.id) ? 'Request' : 'Order' }} status
  .d-flex.align-center.mb-2
    .text-2xl.font-semibold.capitalize {{ displayStatus }}
    v-icon.ml-3(size="20" :color="getStatusColor") {{ getStatusIcon }}
  template(v-if="isPendingApprovalView")
    .d-flex.gap-2.mb-8.to-bottom
      v-btn.button-sm(:loading="isApproving" :disabled="isRejecting" color="success" depressed @click="handleApprove") Approve
      v-btn.button-sm(:loading="isRejecting" :disabled="isApproving" color="danger500" depressed dark @click="handleReject") Reject
  v-btn.button-sm.mb-8.to-bottom(v-else-if="getStatus !== 'archived'" outlined @click="openChangeStatusDialog = true") Change status

  .dialog
    document-change-status-dialog(v-if="openChangeStatusDialog" :open.sync="openChangeStatusDialog" :parentId="parentData.id" :parent-data="parentData" :selectedDocument="selectedDocument" :isCreator="isCreator" @updated="$emit('updated')" @invoiceStatusChanged="$emit('invoiceStatusChanged', $event)")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DocumentChangeStatusDialog from '@/components/clinic/dialogs/purchasehub/DocumentChangeStatusDialog.vue'

export default {
  components: {
    DocumentChangeStatusDialog,
  },
  props: {
    parentData: {
      type: Object,
      default: null
    },
    selectedDocument: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      openChangeStatusDialog: false,
      isApproving: false,
      isRejecting: false,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    hasParentData () {
      return !!this.parentData
    },
    isCreator () {
      if (!this.hasParentData || !this.parentData.company) return true
      const creatorId = typeof this.parentData.company === 'object' ? this.parentData.company.id : this.parentData.company
      return creatorId === this.company.id
    },
    isPendingApprovalView () {
      return this.selectedDocument.id === 'stock-transfer' && !this.isCreator && this.getStatus === 'requested'
    },
    getStatus () {
      if (!this.hasParentData) return ''

      let status
      switch (this.selectedDocument.id) {
        case 'quotation':
          status = this.parentData?.request_status
          break

        case 'purchase-order':
        case 'invoice':
        case 'stock-transfer':
          status = this.parentData?.order_status
          break

        default:
          break
      }

      return status.split('_').join(' ')
    },
    displayStatus () {
      return this.isPendingApprovalView ? 'pending approval' : this.getStatus
    },
    getStatusColor () {
      switch (this.displayStatus) {
        case 'draft':
          return 'normal'
        case 'created':
        case 'active':
        case 'approved':
          return 'green'
        case 'completed':
          return 'blue'
        case 'archived':
        case 'rejected':
          return 'red'
        case 'requested':
        case 'pending approval':
          return 'warning500'
        default:
          return 'grey'
      }
    },
    getStatusIcon () {
      switch (this.displayStatus) {
        case 'draft':
          return '$yzi-file-05'
        case 'created':
        case 'active':
        case 'completed':
        case 'approved':
          return 'mdi-check-bold'
        case 'archived':
          return '$yzi-archive'
        case 'requested':
        case 'pending approval':
          return '$yzi-clock'
        case 'rejected':
          return 'mdi-close-thick'
        default:
          return '$yzi-file-05'
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async handleApprove () {
      this.isApproving = true
      try {
        const { data } = await this.axios.post(`/purchases/${this.company.slug}/stock-transfers/${this.parentData.id}/approve/`)
        this.$emit('updated', data)
      } catch (e) {
        this.showMessage(['error', e.response?.data?.detail || 'Failed to approve'])
      } finally {
        this.isApproving = false
      }
    },
    async handleReject () {
      this.isRejecting = true
      try {
        const { data } = await this.axios.post(`/purchases/${this.company.slug}/stock-transfers/${this.parentData.id}/reject/`)
        this.$emit('updated', data)
      } catch (e) {
        this.showMessage(['error', e.response?.data?.detail || 'Failed to reject'])
      } finally {
        this.isRejecting = false
      }
    },
  },
}
</script>

<style scoped>
.to-bottom {
  position: absolute;
  bottom: 0
}
</style>
